// Orders API.
import { api } from './client.js';

export const createOrder = (payload) => api.post('/orders', payload).then((r) => r.data.order);
export const listOrders = (params) => api.get('/orders', { params: params || {} }).then((r) => r.data.orders);
export const getOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data.order);
// override: approve despite a credit hold / credit-limit breach (a note is then required).
export const approveOrder = (id, note, { override = false } = {}) =>
  api.post(`/orders/${id}/approve`, { ...(note ? { note } : {}), ...(override ? { override: true } : {}) }).then((r) => r.data.order);
// notifyCustomer: email the client that the order wasn't accepted (with the note as the reason).
export const rejectOrder = (id, note, { notifyCustomer = false } = {}) =>
  api.post(`/orders/${id}/reject`, { ...(note ? { note } : {}), notifyCustomer }).then((r) => r.data.order);
// Client / rep: withdraw an order that is still awaiting approval.
export const withdrawOrder = (id, reason) => api.post(`/orders/${id}/withdraw`, reason ? { reason } : {}).then((r) => r.data.order);
export const addOrderNote = (id, text) => api.post(`/orders/${id}/note`, { text }).then((r) => r.data);
export const sendInvoice = (id, body) => api.post(`/orders/${id}/send-invoice`, body || {}).then((r) => r.data);
export const cancelOrder = (id, body) => api.post(`/orders/${id}/cancel`, body || {}).then((r) => r.data.order);
// Staff edit of a still-draft order's line items (add/remove, quantities, price overrides).
// lines: [{ variantId, quantity, unitPrice? }]
export const updateOrderLines = (id, body) => api.patch(`/orders/${id}/lines`, body || {}).then((r) => r.data.order);
export const releaseOrder = (id) => api.post(`/orders/${id}/release`, {}).then((r) => r.data);
export const archiveOrders = (ids) => api.post('/orders/archive', { ids }).then((r) => r.data);
export const restoreOrders = (ids) => api.post('/orders/restore', { ids }).then((r) => r.data);

// PDF endpoints (open as links; the browser sends the auth cookie).
export const invoiceUrl = (id) => `/api/orders/${id}/invoice.pdf`;

// Out-of-stock adjustments (CS): remove items from an approved order + refund the client's paid share.
// removals: [{ variantId, quantity }]
export const previewAdjustment = (id, body) => api.post(`/orders/${id}/adjustments/preview`, body).then((r) => r.data);
export const applyAdjustment = (id, body) => api.post(`/orders/${id}/adjustments`, body).then((r) => r.data);
export const listAdjustments = (id) => api.get(`/orders/${id}/adjustments`).then((r) => r.data.adjustments);

// Paged order list: { orders, total, page, pageSize, summary: [{ currency, subtotal, units, orders }] }.
// summary totals EVERY matching order (excluding rejected / cancelled), not just this page.
export const listOrdersPage = (params) => api.get('/orders', { params: params || {} }).then((r) => r.data);
const qs = (params) => new URLSearchParams(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== '')).toString();
// CSV export of the order list with the same filters (a plain link — the browser sends the auth cookie).
export const ordersCsvUrl = (params) => `/api/orders/export.csv?${qs(params)}`;
// The client's own purchase-order reference.
export const setOrderPo = (id, poNumber) => api.post(`/orders/${id}/po`, { poNumber: poNumber || null }).then((r) => r.data);
